/* eslint-disable */
import { ProfileStore } from '../stores/profile';
import {
    UnitTypeValues,
    addNotification,
    getVisibleUnitTypeValues,
    removeForbiddenFeatureFlags,
    resetServerNotificationsStore,
} from './';
import {
    IRealRole,
    IRoleRight,
    appConfig,
    isCompanyTypeIdMNOHost,
    isCompanyTypeIdMainMaternalCompany,
    isRoleRight,
} from '../settings';
import { IGetApiOk, ITokenInfo, apiManager, tokenManager } from '../REST';
import {
    IAboutInfo,
    IBodyResponseWhoAmIAPI,
    IFeatureFlags,
    IProfileAboutAPI,
    IProfileSettings,
    IUser,
    NotificationType,
} from '../interfaces';
import { mapApi2UiField, objIsNotEmpty, split } from '../instruments';
import { tNM } from '../translate';

export function setProfileAboutStore(about: IAboutInfo): void {
    const ProfileInstance = ProfileStore.getInstance();
    ProfileInstance.setAbout(about);
}
export function cleanProfileAboutStore(): void {
    const ProfileInstance = ProfileStore.getInstance();
    ProfileInstance.cleanAbout();
}

export function setProfileStore(profile: IUser): void {
    const ProfileInstance = ProfileStore.getInstance();
    ProfileInstance.setProfile(profile);
}

const tokenInfo2Profile = (tokenInfo: ITokenInfo): IUser => {
    return { id: tokenInfo.user_id ? tokenInfo.user_id.toString() : '', role: tokenInfo.role };
};

export function setProfileTokenUserInfo(tokenInfo: ITokenInfo): void {
    const ProfileInstance = ProfileStore.getInstance();
    const currentProfile = ProfileInstance.profile;
    ProfileInstance.setProfile({
        ...currentProfile,
        ...tokenInfo2Profile(tokenInfo),
    });
}

function setProfileSettings(settings: IProfileSettings) {
    const ProfileStoreInstance = ProfileStore.getInstance();
    ProfileStoreInstance.setProfileSettings(settings);
}
export function setProfileIsImpersonatingSettings(isImpersonating: boolean) {
    const ProfileStoreInstance = ProfileStore.getInstance();
    ProfileStoreInstance.setIsImpersonating(isImpersonating);
}

function setFeatureFlagRules(flags: IFeatureFlags) {
    const ProfileStoreInstance = ProfileStore.getInstance();
    ProfileStoreInstance.setProfileFeatureFlags(flags);
}

export async function getProfileInfo(isErrorNotification?: boolean): Promise<IGetApiOk> {
    const response = await apiManager.getApi('GET_WHO_AM_I');
    const { isError, resp } = response;

    if (isError) {
        if (isErrorNotification) {
            addNotification({
                type: NotificationType.ERROR,
                message: tNM('Get Profile error'),
                description: objIsNotEmpty(resp) ? JSON.stringify(resp) : null,
                duration: 5,
                isTranslated: true,
                isUsersError: true,
            });
            console.error(`getProfileInfo response error:${resp}`);
        }
    } else {
        const {
            user,
            feature_flags,
            settings,
            tariffs_to_buy_present = false,
            tariff_packages_to_buy_present = false,
        } = resp as IBodyResponseWhoAmIAPI;
        const profileSettings: IProfileSettings = mapApi2UiField(settings || {});
        // profileSettings.bytesPerKb = BytesPerKb.IT;
        // profileSettings.bytesPerKb = BytesPerKb.HUMAN;
        // profileSettings.hideCosts = true;
        // console.log(Date.now(), `--(profileSettings)-  ->`, profileSettings);
        setProfileSettings(profileSettings);
        const profileFeatureFlags = mapApi2UiField(removeForbiddenFeatureFlags(feature_flags || {}));
        setFeatureFlagRules(profileFeatureFlags);
        if (user) {
            const { extracted: companyAndTypeAndCurrency, rest: userCore } = split(user, 'company');
            const { extracted: currency, rest: companyAndType } = split(companyAndTypeAndCurrency, 'currency');
            const { extracted: companyType, rest: companyCore } = split(companyAndType, 'company_type');
            const userId = userCore?.id ? userCore?.id.toString() : '';
            const companyId = companyCore?.id ? companyCore?.id.toString() : undefined;
            const companyName = companyCore?.name;
            const currencyId = currency?.id ? currency?.id.toString() : undefined;
            const companyTypeId = companyType?.id ? companyType?.id.toString() : undefined;
            const companyTypeName = companyType?.name;
            delete companyCore?.id;
            delete companyCore?.name;

            const profileIsMainMaternalCompany = isCompanyTypeIdMainMaternalCompany(companyTypeId);
            const profileIsCompanyTypeIdMNOHost = isCompanyTypeIdMNOHost(companyTypeId);
            const tokenInfo = await tokenManager.getAccessTokenInfo();
            const tokenInfoProfile = tokenInfo2Profile(tokenInfo);

            const profile: IUser = {
                ...(companyCore ? mapApi2UiField(companyCore) : {}),
                ...mapApi2UiField(userCore),
                id: userId,
                companyId,
                company: companyName,
                currency: currency?.symbol,
                currencyId,
                companyType: companyTypeName,
                companyTypeId,
                isMainMaternalCompany: profileIsMainMaternalCompany,
                isCompanyTypeIdMNOHost: profileIsCompanyTypeIdMNOHost,
                tariffsToBuyPresent: tariffs_to_buy_present,
                tariffPackagesToBuyPresent: tariff_packages_to_buy_present,
            };
            setProfileStore({ ...profile, ...tokenInfoProfile });
        }
    }
    resetServerNotificationsStore();

    return !isError;
}

export function getStoreProfileUser(): IUser {
    const ProfileInstance = ProfileStore.getInstance();
    return ProfileInstance.profile;
}
export function getProfileStoreCurrentCompanyId(): string {
    const { companyId } = getStoreProfileUser();
    return companyId || '';
}

export function getProfileStoreIsCompanyTypeIdMNOHost(): boolean {
    const { isCompanyTypeIdMNOHost } = getStoreProfileUser();
    return !!isCompanyTypeIdMNOHost;
}

export function getStoreProfileUserRole(): IRealRole {
    const { role } = getStoreProfileUser();
    return role;
}

export function getProfileUserIsRoleRight(right: IRoleRight): boolean {
    return isRoleRight([right], getStoreProfileUserRole());
}

export function cleanProfileStore(): void {
    const ProfileInstance = ProfileStore.getInstance();
    ProfileInstance.cleanStore();
}

// ------------ FeatureFlagRules ------------

// export async function getFeatureFlagRules(): Promise<void> {
//     const { resp } = await apiManager.getApi('GET_FEATURE_FLAG_RULES');
//     const flags: IFeatureFlags = mapApi2UiField(removeForbiddenFeatureFlags(resp as IFeatureFlagsApi));
//     setFeatureFlagRules(flags);
// }

export function getStoreFeatureFlags(): IFeatureFlags {
    const ProfileStoreInstance = ProfileStore.getInstance();
    return ProfileStoreInstance.profileFeatureFlags;
}
export function getStoreProfileSettings(): IProfileSettings {
    const ProfileStoreInstance = ProfileStore.getInstance();
    return ProfileStoreInstance.profileSettings;
}
export function getStoreVisibleUnitTypes(): UnitTypeValues[] {
    return getVisibleUnitTypeValues(getStoreProfileSettings());
}

export function getFeatureFlagIsExposeValidationErrors(): boolean {
    const flags = getStoreFeatureFlags();
    return !!flags.exposeValidationErrors;
}
export async function getProfileAbout(): Promise<void> {
    let defaultAbout: IAboutInfo = appConfig.about;
    const response = await apiManager.getApi('GET_PROFILE_ABOUT');
    const { isError, resp } = response;
    if (!isError) {
        const aboutResp = resp as IProfileAboutAPI;
        const aboutId = aboutResp?.about?.id;

        if (aboutId) {
            defaultAbout = { ...mapApi2UiField(aboutResp?.about || {}) } as IAboutInfo;
        }
    }
    setProfileAboutStore(defaultAbout);
}
